import { APIFetchV3, RequestHeaders } from "@certa/network";
import { z } from "zod";
import type { UserMentionSearchParams } from "../types/userMentions.types";
import { userMentionsModelCreator } from "../models/userMentions.models";

const UserMentionAPIResponseSchema = z.object({
  id: z.number(),
  email: z.string(),
  full_name: z.string()
});

const UserMentionsListResponseSchema = z.array(UserMentionAPIResponseSchema);

export type UserMentionAPIResponse = z.infer<
  typeof UserMentionAPIResponseSchema
>;
export type UserMentionsListResponse = z.infer<
  typeof UserMentionsListResponseSchema
>;

export const getUsersWhoCanBeMentioned = ({
  threadId,
  searchTerm
}: UserMentionSearchParams) => {
  const requestOptions: RequestInit = {
    method: "GET",
    headers: RequestHeaders.GET,
    credentials: "include"
  };

  const queryParams = searchTerm
    ? `?search_term=${encodeURIComponent(searchTerm)}`
    : "";

  const url = `threads/${threadId}/users-who-can-be-mentioned/${queryParams}`;

  return APIFetchV3<UserMentionsListResponse>(url, requestOptions).then(
    response => {
      // Validate response with Zod schema
      const validatedResponse = UserMentionsListResponseSchema.parse(response);
      return userMentionsModelCreator(validatedResponse);
    }
  );
};
